import React, { Component } from 'react';

import './ItemToggle.css';

export default class ItemToggle extends Component{
    constructor(props){
        super(props);
        
        
        let items = this.props.items;
        let dots = [];
        this.itemIndex = 0;
        this.itemValue = [];
        for(let p in items){            
            this.itemValue.push(p);
        }
        let value = this.itemValue[this.itemIndex];

        console.log("ItemToggle Value:", this.props.items[value])

        this.state = {
            currentItem: this.props.items[value]
        };

        this.handleClick = this.handleClick.bind(this);
    }

    getNameIndex(name){
        for(let i=0; i < this.itemValue.length; i++){
            if(this.itemValue[i] == name){
                return i;
            }
        }
        return null;
    }

    componentDidMount(){
        if(this.props.value){
            //console.log('item toggle mounted:', this.props.value);
            let index = this.getNameIndex(this.props.value);
            if(index !== null){
                this.itemIndex = index;
                this.setState({currentItem: this.props.items[this.props.value]});
            }

            
        }

    }


    

    drawDots(){
        let items = this.props.items;
        let dots = [];
        for(let p in items){
            let activeClass = (this.itemValue[this.itemIndex] == p)? 'active' : '';
            dots.push(
                <div>
                    <div><span className={'dot ' + activeClass} value={p}></span></div>
                </div>
            )
        }

        return dots;
    }

    handleClick(){
        this.itemIndex = (this.itemIndex + 1) % this.itemValue.length;
        let value = this.itemValue[this.itemIndex];
        this.setState({currentItem: this.props.items[value]});

        if(this.props.onChange){
            this.props.onChange(value);
        }
    }

    render(){
        return(
            <div className={'item-toggle ' + (this.props.className || '')} onClick={this.handleClick}>
                <div className='table inline align-middle align-center'>
                    <div>
                        <div>{this.state.currentItem}</div>
                        <div>
                            <div className='table vmax align-middle align-center'>{this.drawDots()}</div>                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ItemToggle.js